import request from '@/utils/request'
import qs from 'qs'
// banner - list
export const getBannerList = (data: any) =>
  request({
    url: '/banner/list',
    method: 'get',
    params: data
  })
// banner edit info
export const getBannerEditInfo = (data: any) =>
  request({
    url: '/banner/edit',
    method: 'get',
    params: data
  })
// banner type
export const getBannerType = () =>
  request({
    url: '/banner/mapping',
    method: 'get'
  })

// set top
export const setBannerTop = (data: { nid: number, ids: string, isTop: 1 | -1 }) =>
  request({
    url: '/banner/top',
    method: 'post',
    data: qs.stringify(data)
  })
// delete
export const deleteBanner = (data: { nid: number, ids: string}) =>
  request({
    url: '/banner/delete',
    method: 'post',
    data: qs.stringify(data)
  })

interface IAddEditBanner {
  id: number,
  relateId: number,
  nids: string,
  name: string,
  bannerType: string,
  startDate: string,
  endDate: string,
  isShow: 1 | -1,
  isExternal: 1 | -1,
  seq: string | number,
  imgUrl: string,
  imgLink: string
  isIos: number
}
// edit & add
export const addEditBanner = (data: IAddEditBanner) =>
  request({
    url: '/banner/option',
    method: 'post',
    data: qs.stringify(data)
  })
